// extracted by mini-css-extract-plugin
export default {"reportsWrap":"reports_reportsWrap__zIU99","actions":"reports_actions__yvT7W"};